import { Publisher } from "./Publisher";
import { HallMaintenanceTask } from "./HallMaintenanceTask";

export enum HallMaintenanceTaskAssignmentStatus {
    NotStarted = 'not_started',
    InProgress = 'in_progress',
    Completed = 'completed',
}

export interface HallMaintenanceTaskAssignment {
    id: number;
    taskId: number;
    task?: HallMaintenanceTask;
    assigneeId?: number;
    assignee?: Publisher;
    customAssignee?: string;
    startDate: Date;
    endDate?: Date;
    status?: HallMaintenanceTaskAssignmentStatus;
    resultSummary?: string;
    createdAt: Date;
    updatedAt: Date;
}
